import { swe } from "./dictionary";

export default (texts, ...interpolated) => {
  return swe[texts[0]] ? swe[texts[0]] : texts[0];
};
